import React from "react";
import arrowup from "../../images/green-arrow-up.svg";
import arrowdown from "../../images/red-arrow-down.svg";
import { useQuery } from "@apollo/react-hooks";
import { monoClient } from "../../apolloClient";
import { GET_COUNCIL_STATISTIC } from "../../query/getDashBoardData";
import moment from "moment";
import map from "../../images/curve.svg";

const DashboardNumeric = ({
  startDate,
  endDate,
  comparisonStartDate,
  comparisonEndDate,
  isPrint,
}) => {
  const { data } = useQuery(GET_COUNCIL_STATISTIC, {
    client: monoClient,
    fetchPolicy: "cache-and-network",
    variables: {
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).add(1, "day").format("YYYY-MM-DD"),
      comparisonStartDate: moment(comparisonStartDate).format("YYYY-MM-DD"),
      comparisonEndDate: moment(comparisonEndDate)
        .add(1, "day")
        .format("YYYY-MM-DD"),
      council_profile_id: localStorage.getItem("profile_id"),
    },
  });

  return (
    <ul className="dashboard-numeric">
      <li style={isPrint ? { display: "inline-block", width: "300px" } : {}}>
        <div
          className="dashboard-numeric-row"
          style={isPrint ? { display: "inline-block" } : {}}
        >
          <div
            className="numeric-row-left"
            style={isPrint ? { display: "inline-block" } : {}}
          >
            <label
              style={
                isPrint
                  ? {
                      fontWeight: "400",
                      color: "#161f3d",
                      fontSize: "15px",
                      lineHeight: "18px",
                      marginBottom: "8px",
                    }
                  : {}
              }
            >
              Total Tickets Income
            </label>
            <p
              style={
                isPrint
                  ? {
                      color: "#161f3d",
                      fontWeight: "600",
                      margin: "0px",
                      fontSize: "24px",
                      lineHeight: "30px",
                    }
                  : {}
              }
            >
              $
              {data?.getCouncilDashboardOverviewStatistics?.totalTicketsIncome?.value?.toFixed(
                2
              ) > 1000
                ? `${(
                    data?.getCouncilDashboardOverviewStatistics
                      ?.totalTicketsIncome?.value / 1000
                  ).toFixed(2)}k`
                : data?.getCouncilDashboardOverviewStatistics?.totalTicketsIncome?.value?.toFixed(
                    2
                  )}
              <span
                style={
                  isPrint
                    ? {
                        color:
                          data?.getCouncilDashboardOverviewStatistics
                            ?.totalTicketsIncome?.percentageDiff > 0
                            ? "green"
                            : "red",
                        fontSize: "14px",
                        marginLeft: "7px",
                        display: "inline-block",
                      }
                    : {}
                }
                class={
                  data?.getCouncilDashboardOverviewStatistics
                    ?.totalTicketsIncome?.percentageDiff > 0
                    ? "green"
                    : "red"
                }
              >
                {data?.getCouncilDashboardOverviewStatistics?.totalTicketsIncome
                  ?.percentageDiff > 0 ? (
                  <img src={arrowup} alt="arrow up" />
                ) : (
                  <img src={arrowdown} alt="arrow down" />
                )}
                {data?.getCouncilDashboardOverviewStatistics?.totalTicketsIncome?.percentageDiff?.toFixed(
                  2
                ) > 1000
                  ? `${(
                      data?.getCouncilDashboardOverviewStatistics
                        ?.totalTicketsIncome?.percentageDiff / 1000
                    ).toFixed(2)}k`
                  : data?.getCouncilDashboardOverviewStatistics?.totalTicketsIncome?.percentageDiff?.toFixed(
                      2
                    )}
                %
              </span>
            </p>
          </div>
          <div
            className="numeric-row-right"
            style={isPrint ? { display: "inline-block" } : {}}
          >
            <img
              src={map}
              alt="Total profile visualization"
              style={
                isPrint
                  ? {
                      display: "inline-block",
                      width: "100px",
                      marginLeft: "30px",
                    }
                  : {}
              }
            />
          </div>
        </div>
      </li>
      <div
        style={
          isPrint
            ? {
                borderLeft: "1px solid #e6e6e6",
                height: "60px",
                width: "1px",
                display: "inline-block",
                position: "absolute",
                marginTop: "5px",
              }
            : {}
        }
      ></div>
      <li
        style={
          isPrint
            ? { display: "inline-block", width: "300px", marginLeft: "3%" }
            : {}
        }
      >
        <div
          className="dashboard-numeric-row"
          style={isPrint ? { display: "inline-block" } : {}}
        >
          <div
            className="numeric-row-left"
            style={isPrint ? { display: "inline-block" } : {}}
          >
            <label
              style={
                isPrint
                  ? {
                      fontWeight: "400",
                      color: "#161f3d",
                      fontSize: "15px",
                      lineHeight: "18px",
                      marginBottom: "8px",
                    }
                  : {}
              }
            >
              Total Tickets Sold
            </label>
            <p
              style={
                isPrint
                  ? {
                      color: "#161f3d",
                      fontWeight: "600",
                      margin: "0px",
                      fontSize: "24px",
                      lineHeight: "30px",
                    }
                  : {}
              }
            >
              {
                data?.getCouncilDashboardOverviewStatistics?.totalTicketsSold
                  ?.value
              }
              <span
                class="red"
                style={
                  isPrint
                    ? {
                        color:
                          data?.getCouncilDashboardOverviewStatistics
                            ?.totalTicketsSold?.percentageDiff > 0
                            ? "green"
                            : "red",
                        fontSize: "14px",
                        marginLeft: "7px",
                        display: "inline-block",
                      }
                    : {}
                }
              >
                {data?.getCouncilDashboardOverviewStatistics?.totalTicketsSold
                  ?.percentageDiff > 0 ? (
                  <img src={arrowup} alt="arrow up" />
                ) : (
                  <img src={arrowdown} alt="arrow down" />
                )}
                {data?.getCouncilDashboardOverviewStatistics?.totalTicketsSold?.percentageDiff?.toFixed(
                  2
                ) > 1000
                  ? `${(
                      data?.getCouncilDashboardOverviewStatistics
                        ?.totalTicketsSold?.percentageDiff / 1000
                    ).toFixed(2)}k`
                  : data?.getCouncilDashboardOverviewStatistics?.totalTicketsSold?.percentageDiff?.toFixed(
                      2
                    )}
                %
              </span>
            </p>
          </div>
          <div
            className="numeric-row-right"
            style={isPrint ? { display: "inline-block" } : {}}
          >
            <img
              src={map}
              alt="Total profile visualization"
              style={isPrint ? { display: "inline-block", width: "100px" } : {}}
            />
          </div>
        </div>
      </li>
      <div
        style={
          isPrint
            ? {
                borderLeft: "1px solid #e6e6e6",
                height: "60px",
                width: "1px",
                display: "inline-block",
                position: "absolute",
                marginTop: "5px",
              }
            : {}
        }
      ></div>
      <li
        style={
          isPrint
            ? { display: "inline-block", width: "300px", marginLeft: "3%" }
            : {}
        }
      >
        <div
          className="dashboard-numeric-row"
          style={isPrint ? { display: "inline-block" } : {}}
        >
          <div
            className="numeric-row-left"
            style={isPrint ? { display: "inline-block" } : {}}
          >
            <label
              style={
                isPrint
                  ? {
                      fontWeight: "400",
                      color: "#161f3d",
                      fontSize: "15px",
                      lineHeight: "18px",
                      marginBottom: "8px",
                    }
                  : {}
              }
            >
              Total Events created
            </label>
            <p
              style={
                isPrint
                  ? {
                      color: "#161f3d",
                      fontWeight: "600",
                      margin: "0px",
                      fontSize: "24px",
                      lineHeight: "30px",
                    }
                  : {}
              }
            >
              {
                data?.getCouncilDashboardOverviewStatistics?.totalEventCreated
                  ?.value
              }
              <span
                style={
                  isPrint
                    ? {
                        color:
                          data?.getCouncilDashboardOverviewStatistics
                            ?.totalEventCreated?.percentageDiff > 0
                            ? "green"
                            : "red",
                        fontSize: "14px",
                        marginLeft: "7px",
                        display: "inline-block",
                      }
                    : {}
                }
                class={
                  data?.getCouncilDashboardOverviewStatistics?.totalEventCreated
                    ?.percentageDiff > 0
                    ? "green"
                    : "red"
                }
              >
                {data?.getCouncilDashboardOverviewStatistics?.totalEventCreated
                  ?.percentageDiff > 0 ? (
                  <img src={arrowup} alt="arrow up" />
                ) : (
                  <img src={arrowdown} alt="arrow down" />
                )}
                {data?.getCouncilDashboardOverviewStatistics?.totalEventCreated?.percentageDiff?.toFixed(
                  2
                ) > 1000
                  ? `${(
                      data?.getCouncilDashboardOverviewStatistics
                        ?.totalEventCreated?.percentageDiff / 1000
                    ).toFixed(2)}k`
                  : data?.getCouncilDashboardOverviewStatistics?.totalEventCreated?.percentageDiff?.toFixed(
                      2
                    )}
                %
              </span>
            </p>
          </div>
          <div
            className="numeric-row-right"
            style={isPrint ? { display: "inline-block" } : {}}
          >
            <img
              src={map}
              alt="Total profile visualization"
              style={isPrint ? { display: "inline-block", width: "100px" } : {}}
            />
          </div>
        </div>
      </li>
    </ul>
  );
};
export default DashboardNumeric;
